// two bobby: add-to-cart feedback (18 Oct 2026). The cart no longer opens on add (founders), so:
//   • after every successful add (product page, quick add, cart add-ons — all fire Shopify's standard cartLinesUpdate
//     event with action "add") a small toast pops up for 3 seconds: "✓ Added to cart · View cart →", and the header bag
//     icon bumps;
//   • when any cart change takes the total from below to at/above the free-shipping threshold, the toast says
//     "Free shipping unlocked!" and a short confetti burst plays (once per visit, never with reduced motion).
// Loaded on every page from snippets/tb-added-toast.liquid (rendered by cart-drawer.liquid even when the cart is empty).
// Cost: one small /cart.js read after a cart change (none on page load); confetti is a 1.6 s canvas, removed after.
import { StandardEvents } from '@shopify/events';

const toast = document.getElementById('tb-added-toast');
const msg = toast?.querySelector('[data-tb-toast-msg]');
const freeFrom = Number(toast?.dataset.freeFrom || 0);
let total = Number(toast?.dataset.total || 0);
let timer = 0;
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function show(text, free) {
  if (!toast) return;
  if (msg) msg.textContent = text;
  toast.classList.toggle('tb-added-toast--free', !!free);
  toast.hidden = false;
  toast.classList.remove('is-in');
  void toast.offsetWidth; // restart the entrance animation
  toast.classList.add('is-in');
  clearTimeout(timer);
  timer = setTimeout(hide, free ? 3500 : 3000);
}

function hide() {
  if (!toast) return;
  toast.classList.remove('is-in');
  setTimeout(() => { if (!toast.classList.contains('is-in')) toast.hidden = true; }, 250);
}

function bumpBag() {
  if (reduced) return;
  document.querySelectorAll('cart-icon').forEach((icon) => {
    icon.classList.remove('tb-bump');
    void icon.offsetWidth;
    icon.classList.add('tb-bump');
    setTimeout(() => icon.classList.remove('tb-bump'), 700);
  });
}

function confetti() {
  if (reduced) return;
  try {
    if (sessionStorage.getItem('tb_confetti')) return;
    sessionStorage.setItem('tb_confetti', '1');
  } catch (e) { /* storage blocked: still celebrate */ }
  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000';
  document.body.appendChild(canvas);
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const w = (canvas.width = innerWidth * dpr);
  const h = (canvas.height = innerHeight * dpr);
  const ctx = canvas.getContext('2d');
  const colours = ['#d33b4a', '#f4a7c0', '#f6d27a', '#a8e0cf', '#c8b6e2', '#ffffff'];
  const bits = Array.from({ length: 90 }, () => ({
    x: w / 2 + (Math.random() - 0.5) * w * 0.3,
    y: h * 0.75,
    vx: (Math.random() - 0.5) * 14 * dpr,
    vy: -(8 + Math.random() * 12) * dpr,
    r: (3 + Math.random() * 4) * dpr,
    rot: Math.random() * Math.PI,
    vr: (Math.random() - 0.5) * 0.3,
    c: colours[(Math.random() * colours.length) | 0],
  }));
  const start = performance.now();
  (function frame(now) {
    const t = now - start;
    ctx.clearRect(0, 0, w, h);
    for (const b of bits) {
      b.vy += 0.45 * dpr;
      b.vx *= 0.99;
      b.x += b.vx;
      b.y += b.vy;
      b.rot += b.vr;
      ctx.save();
      ctx.globalAlpha = Math.max(0, 1 - t / 1600);
      ctx.translate(b.x, b.y);
      ctx.rotate(b.rot);
      ctx.fillStyle = b.c;
      ctx.fillRect(-b.r, -b.r / 2, b.r * 2, b.r);
      ctx.restore();
    }
    if (t < 1600) requestAnimationFrame(frame);
    else canvas.remove();
  })(start);
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const added = event.action === 'add';
  const before = total;
  const done = async (detail) => {
    if (detail && detail.didError) return;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      total = Number(cart.total_price || 0);
    } catch (e) { /* keep the old total */ }
    const unlocked = freeFrom > 0 && before < freeFrom && total >= freeFrom;
    const drawer = document.getElementById('cart-drawer');
    if (unlocked) confetti();
    if (added) bumpBag();
    if (drawer && drawer.isOpen) return; // the cart itself shows the update
    if (unlocked) show('Free shipping unlocked 🎉', true);
    else if (added) show('Added to cart', false);
  };
  const p = event.promise;
  if (p && typeof p.then === 'function') p.then((r) => done(r && r.detail)).catch(() => {});
  else done();
});

toast?.querySelector('[data-tb-view-bag]')?.addEventListener('click', (e) => {
  e.preventDefault();
  hide();
  const drawer = document.getElementById('cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
  else window.location.href = '/cart';
});
